// A5.4: единый форматтер сумм (совпадает с _fmt_rub на бэкенде): разряды через неразрывный пробел, без «.0»
const RUB = new Intl.NumberFormat("ru-RU", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export const formatRub = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0";
  return RUB.format(n).replace(/\u202f/g, "\u00a0");
};

export const formatRubWithSign = (value) => `${formatRub(value)}\u00a0₽`;
